import formatName from 'I18n/utils/formatName';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { useQuery, gql } from '@apollo/client';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const isCompanyDataType = selectedObjectData => typeof selectedObjectData.website === 'string';
export const isContactDataType = selectedObjectData => typeof selectedObjectData.email === 'string';
export const isDealDataType = selectedObjectData => typeof selectedObjectData.pipeline === 'string';
const selectedObjectsQuery = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"BulkBetButtonsSelectedObjectProperties\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"ids\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectType\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjects\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"ids\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"ids\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectType\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Contact\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"ListValue\",\"values\":[{\"kind\":\"StringValue\",\"value\":\"firstname\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"lastname\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"email\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"hubspot_owner_id\",\"block\":false}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Company\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"ListValue\",\"values\":[{\"kind\":\"StringValue\",\"value\":\"name\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"hubspot_owner_id\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"sales_ops_managed_exempt_from_capacity_limit\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"website\",\"block\":false}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Deal\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"ListValue\",\"values\":[{\"kind\":\"StringValue\",\"value\":\"dealstage\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"hubspot_owner_id\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"pipeline\",\"block\":false},{\"kind\":\"StringValue\",\"value\":\"quote_purchase_date\",\"block\":false}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeDefinition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "BulkBetButtonsSelectedObjectProperties"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "ids"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Long"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectType"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjects"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "ids"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "ids"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectType"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Contact"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "properties"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "names"
                  },
                  value: {
                    kind: "ListValue",
                    values: [{
                      kind: "StringValue",
                      value: "firstname",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "lastname",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "email",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "hubspot_owner_id",
                      block: false
                    }]
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "name"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Company"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "properties"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "names"
                  },
                  value: {
                    kind: "ListValue",
                    values: [{
                      kind: "StringValue",
                      value: "name",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "hubspot_owner_id",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "sales_ops_managed_exempt_from_capacity_limit",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "website",
                      block: false
                    }]
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "name"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Deal"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "properties"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "names"
                  },
                  value: {
                    kind: "ListValue",
                    values: [{
                      kind: "StringValue",
                      value: "dealstage",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "hubspot_owner_id",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "pipeline",
                      block: false
                    }, {
                      kind: "StringValue",
                      value: "quote_purchase_date",
                      block: false
                    }]
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "name"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "objectTypeDefinition"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
const _findContactPropertyByName = (properties, propertyName) => {
  return properties.find(({
    name
  }) => name === propertyName) || {};
};
const _findCompanyPropertyByName = (properties, propertyName) => {
  return properties.find(({
    name
  }) => name === propertyName) || {};
};
const _findDealPropertyByName = (properties, propertyName) => {
  return properties.find(({
    name
  }) => name === propertyName) || {};
};
const getObjectLabel = property => {
  const objectTypeId = getIn(['objectTypeDefinition', 'id'], property);
  const properties = get('properties', property);
  if (objectTypeId === CONTACT_TYPE_ID) {
    const {
      value: hubspot_owner_id
    } = _findContactPropertyByName(properties, 'hubspot_owner_id');
    const {
      value: firstName
    } = _findContactPropertyByName(properties, 'firstname');
    const {
      value: lastName
    } = _findContactPropertyByName(properties, 'lastname');
    const {
      value: email
    } = _findContactPropertyByName(properties, 'email');
    return {
      hubspot_owner_id,
      email,
      name: formatName({
        email,
        firstName,
        lastName
      })
    };
  }
  if (objectTypeId === COMPANY_TYPE_ID) {
    const {
      value: hubspot_owner_id
    } = _findCompanyPropertyByName(properties, 'hubspot_owner_id');
    const {
      value: name
    } = _findCompanyPropertyByName(properties, 'name');
    const {
      value: sales_ops_managed_exempt_from_capacity_limit
    } = _findCompanyPropertyByName(properties, 'sales_ops_managed_exempt_from_capacity_limit');
    const {
      value: website
    } = _findCompanyPropertyByName(properties, 'website');
    return {
      hubspot_owner_id,
      name,
      sales_ops_managed_exempt_from_capacity_limit,
      website
    };
  }
  if (objectTypeId === DEAL_TYPE_ID) {
    const {
      value: dealstage
    } = _findDealPropertyByName(properties, 'dealstage');
    const {
      value: hubspot_owner_id
    } = _findDealPropertyByName(properties, 'hubspot_owner_id');
    const {
      value: pipeline
    } = _findDealPropertyByName(properties, 'pipeline');
    const {
      value: quote_purchase_date
    } = _findDealPropertyByName(properties, 'quote_purchase_date');
    return {
      dealstage,
      hubspot_owner_id,
      pipeline,
      quote_purchase_date
    };
  }
  return null;
};
export const useFetchSelectedObjects = ({
  objectType,
  objectIds
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(selectedObjectsQuery, {
    variables: {
      ids: objectIds,
      objectType
    }
  });
  if (loading) {
    return {
      isLoading: true
    };
  } else if (error || !data) {
    return {
      isLoading: false,
      selectedObjectsData: []
    };
  }
  const crmObjects = data.crmObjects;
  const selectedObjectsData = crmObjects.map(fetchedProperty => Object.assign({
    id: get('id', fetchedProperty)
  }, getObjectLabel(fetchedProperty)));
  return {
    isLoading: false,
    selectedObjectsData
  };
};